<template>
	<o-card
		v-if="setup.dataLoaded"
		class="dashboard-profile-completion card--no-hover">
		<div
			class="row row--grid">
			<div
				v-if="setup.profileCompletion"
				class="col-md-4 col-lg-4 col-xl-3">
				<div class="dashboard-profile-completion__header">
					<div class="dashboard-profile-completion__header-content">
						<div>
							<h4 class="dashboard-profile-completion__title">Votre Profil est presque terminé</h4>
							<p class="dashboard-profile-completion__subtitle">
								Donnez-vous les chances de <br>
								<span class="text--success">décrocher</span>  ce merveilleux job
							</p>
						</div>

						<img
							class="dashboard-profile-completion__img"
							src="@Img/illustration/documents.svg"
							alt="folder">
					</div>
				</div>
			</div>
			<div
				v-if="setup.profileCompletion && !!setup.user"
				class="col-md-8 col-lg-8 col-xl-9">
				<div class="row row--grid">
					<div class="col-md-12 col-xl-12 flex fw-w">
						<dashboard-temp-worker-profile-completion-sticker
							class="half-width"
							:user="setup.user"
							:title="`CV/Curriculum Vitae`"
							:is-missing="!setup.hasCurriculumVitae"
							:type-label="`CurriculumVitae`"
							:document-type="TEMP_WORKER_DOCUMENT_TYPE.CurriculumVitae"/>
						<dashboard-temp-worker-profile-completion-sticker
							class="half-width"
							:user="setup.user"
							:title="`Diplômes`"
							:is-missing="!setup.hasDiploma"
							:type-label="`Diploma`"
							:document-type="TEMP_WORKER_DOCUMENT_TYPE.Diploma"/>
						<dashboard-temp-worker-profile-completion-sticker
							class="half-width"
							:user="setup.user"
							:title="`Qualifications`"
							:is-missing="!setup.hasProfessionalSkill"
							:type-label="`Skill`"
							@uploaded="setup.updateProfessionalSkills(); setup.updateStateOfProfileCompletionCard ()"/>
						<dashboard-temp-worker-profile-completion-sticker
							class="half-width"
							:user="setup.user"
							:title="`Expériences`"
							:is-missing="!setup.hasExperience"
							:type-label="`Experience`"
							@uploaded="setup.updateProfessionalExperience(); setup.updateStateOfProfileCompletionCard()"/>
						<dashboard-temp-worker-profile-completion-sticker
							class="half-width"
							:user="setup.user"
							:title="`Carte d'identité`"
							:is-missing="!setup.hasIdentityPiece"
							:type-label="`IdentityPiece`"
							:document-type="TEMP_WORKER_DOCUMENT_TYPE.IdentityPiece"/>
						<dashboard-temp-worker-profile-completion-sticker
							class="half-width"
							:user="setup.user"
							:title="`Att. de sécurité sociale`"
							:is-missing="!setup.hasSocialCertificate"
							:type-label="`SocialCertificate`"
							:document-type="TEMP_WORKER_DOCUMENT_TYPE.SocialCertificate"/>
					</div>
				</div>
			</div>
			<o-loader :visible="!setup.dataLoaded"/>
		</div>
	</o-card>
</template>

<script setup lang="ts">
import DashboardProfileCompletionCardSetupService from '@/setup/dashboard/DashboardProfileCompletionCardSetupService';
import { TEMP_WORKER_DOCUMENT_TYPE } from '@/typings/enums/TEMP_WORKER_DOCUMENT_TYPE';
import DashboardTempWorkerProfileCompletionSticker from '@/components/dashboard/temp-worker/DashboardTempWorkerProfileCompletionSticker.vue';
type Emits = { (e: 'hide'): void }
const emits = defineEmits<Emits>();
const setup = new DashboardProfileCompletionCardSetupService(emits);
</script>

<style lang="less">
@import '@/styles/variables';
@import '@/styles/mixins';

.dashboard-profile-completion {
	height: 100%;

	&__header {
		.flex-align(center, flex-start);
		height: calc(100%);
		padding: 0 0.6rem;

		@media @tablet {
			padding: 0 15% 0 1.3rem;
		}

		@media @phone {
			margin-top: 0.6rem;
		}

		&-content {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;

			@media @tabletLandscape {
				flex-direction: column;
			}
		}
	}

	&__title {
		color: var(--grey-darker);
		text-transform: uppercase;
		margin-bottom: 0.6rem;
	}

	&__img {
		margin-left: 1.9rem;
		width: 11.2rem;
		height: auto;
		display: none;

		@media @tablet {
			display: block;
			margin-left: 0;
			margin-top: 1.3rem;
		}

		@media @desktop {
			display: none;
		}
	}

	&__subtitle {
		font-weight: 400;
		font-size: 0.9rem;
	}

	.orion-card__body{
		padding: 1.9rem 1.6rem;
	}

	.half-width{
		width: 100%;
		max-width: unset;
		min-width: unset;
	}


	.orion-card__body{
		padding: 0.9rem 1.6rem;
	}

	.orion-sticker + .orion-sticker{
		margin-top: 6px;
	}

	.half-width {
		width: 100%;
		min-width: 280px;
		margin: 6px;

		@media @tablet{
			width: calc(50% - 12px);
		}

		@media @desktop {
			max-width: 298px;
		}

		@media @phone ,@tabletOnly {
			.bubble-indicator {
				transform: translate3d(0, 0, 0);
				opacity: 1;
			}
		}
	}
}


</style>
